export default function RegionalCreation() {
  const approaches = [
    {
      icon: 'ri-building-2-line',
      title: '地域資源の活用',
      description: '廃校などの未利用施設を、新しい産業の拠点として再生させます。地域に眠る資源を最大限に活用し、持続可能な地域経済の基盤を構築します。'
    },
    {
      icon: 'ri-flask-line',
      title: '大学との連携',
      description: '筑波大学をはじめとする研究機関と連携し、最先端の技術を地域に導入します。学術研究の成果を実用化し、地域の産業発展に貢献します。'
    },
    {
      icon: 'ri-team-line',
      title: '雇用の創出',
      description: '新しい産業の創出により、地域に安定した雇用を生み出します。働く場所と住む場所を同時に提供することで、若い世代の定着を促進します。'
    },
    {
      icon: 'ri-recycle-line',
      title: '循環型社会の実現',
      description: '環境負荷の少ない循環型システムを構築し、持続可能な地域社会を実現します。経済活動と環境保全を両立させる新しいモデルを提示します。'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">地域創生へのアプローチ</h2>
          <div className="w-20 h-1 bg-teal-600 mx-auto mb-6"></div>
          <p className="text-base text-gray-700 max-w-3xl mx-auto leading-relaxed">
            私たちは、地域が持つ固有の資源と最先端の技術を融合させることで、<br />
            持続可能な地域社会の実現を目指します。
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16">
          {approaches.map((approach, index) => (
            <div
              key={index}
              className="rounded-lg p-8 hover:shadow-lg transition-shadow duration-300 text-center"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-teal-600 text-white rounded-lg mb-6 mx-auto">
                <i className={`${approach.icon} text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{approach.title}</h3>
              <p className="text-sm text-gray-700 leading-relaxed">{approach.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-teal-600 to-green-600 rounded-lg p-12 text-white text-center">
          <h3 className="text-3xl font-bold mb-6">地域と共に成長する</h3>
          <p className="text-base leading-relaxed max-w-3xl mx-auto mb-8">
            私たちは、地域の皆様と共に歩み、共に成長することを大切にしています。地域の声に耳を傾け、地域のニーズに応える事業を展開することで、真に持続可能な地域社会の実現を目指します。地域の未来は、私たち全員で創るものです。
          </p>
          <div className="flex flex-wrap justify-center gap-6 text-sm">
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-fill text-xl"></i>
              <span>地域住民との対話</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-fill text-xl"></i>
              <span>自治体との協力</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-fill text-xl"></i>
              <span>地域企業との連携</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-fill text-xl"></i>
              <span>継続的な改善</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}